import React from "react";

import { Navigate, Route, Routes } from "react-router-dom";

// Layouts

import PatientLayout from "../components/layouts/PatientLayout";

import PatientAppointmentsDetails from "../containers/patient-flow/paitent-appointment-details/PatientAppointmentsDetails";
import PatientAppointment from "../containers/patient-flow/patient-appointment/PatientAppointment";
import PatientBookAppointment from "../containers/patient-flow/patient-book-appointment/PatientBookAppointment";
import PatientCompleteProfile from "../containers/patient-flow/patient-complete-profile/PatientCompleteProfile";
import PatientConfirmBooking from "../containers/patient-flow/patient-confirm-booking/PatientConfirmBooking";
import PatientDoctorListings from "../containers/patient-flow/patient-doctor-listing/PatientDoctorListings";
import PatientDoctorProfile from "../containers/patient-flow/patient-doctor-profile/PatientDoctorProfile";
import PatientFindDoctor from "../containers/patient-flow/patient-find-doctor/PatientFindDoctor";
import PatientPaymentHistory from "../containers/patient-flow/patient-payment-history/PatientPaymentHistory";
import PatientPrescription from "../containers/patient-flow/patient-prescription/PatientPrescription";
import PatientProfile from "../containers/patient-flow/patient-profile/PatientProfile";
import PatientQuestionnaire from "../containers/patient-flow/patient-questionnaire/PatientQuestionnaire";

// GUARDS
import { useSelector } from "react-redux";
import PrescriptionDetails from "../components/patient-side-components/patient-prescription-table/prescription-details/PrescriptionDetails";
import PatientVideoCallPanel from "../containers/patient-flow/patient-video-call/PatientVideoCallPanel";
import { PatientProtectedRoute } from "./patientRoutesGuard";

const PatientRoutes = () => {
  const user = useSelector((state) => state.userReducer.user);

  return (
    <Routes>
      <Route path="/patient" element={<PatientLayout />}>
        {/* Add explicit route for the base patient path */}
        <Route
          path="complete-profile"
          element={
            user && !user.isProfileComplete ? (
              <PatientCompleteProfile />
            ) : (
              <Navigate to="/patient/find-doctor" replace />
            )
          }
        />
        <Route index element={<Navigate to="/patient/find-doctor" replace />} />

        {/* PRIVATE PATIENT ROUTES */}
        <Route element={<PatientProtectedRoute />}>
          <Route path="find-doctor" element={<PatientFindDoctor />} />
          <Route path="doctor-listing" element={<PatientDoctorListings />} />
          <Route path="doctor-profile" element={<PatientDoctorProfile />} />
          <Route path="book-appointment" element={<PatientBookAppointment />} />

          <Route
            path="confirm-appointment"
            element={<PatientConfirmBooking />}
          />

          <Route
            path="confirm-questionnaire"
            element={<PatientQuestionnaire />}
          />
          <Route
            path="appointments-details"
            element={<PatientAppointmentsDetails />}
          />

          <Route path="profile" element={<PatientProfile />} />
          <Route path="payments" element={<PatientPaymentHistory />} />
          <Route path="prescription" element={<PatientPrescription />} />
          <Route
            path="prescription-details"
            element={<PrescriptionDetails />}
          />
          <Route path="appointment" element={<PatientAppointment />} />
          <Route
            path="patient-consultation-panel"
            element={<PatientVideoCallPanel />}
          />
        </Route>
      </Route>
      {/* REDIRECT TO DASHBOARD IF ANY UNKNOW ROUTE APPEARS */}
      <Route
        path="*"
        element={<Navigate to="/patient/find-doctor" replace />}
      />
    </Routes>
  );
};

export default PatientRoutes;
